import { Icon } from './Icon';

/** Убрать насовсем: снос внешки, очистка поля с картинкой. */
export function TrashIcon({ size }: { size?: number }) {
  return (
    <Icon size={size}>
      <path d="M2.4 3.7 h9.2" />
      <path d="M3.6 3.7 L4.3 12.3 h5.4 L10.4 3.7" />
      <path d="M5.5 3.7 V1.8 h3 V3.7" />
    </Icon>
  );
}
